import React from 'react';

import TableColumnTitle from '../../../../../../../../components/_table/TableColumnTitle';
import TableFilterInput from '../../../../../../../../components/_table/TableFilterInput';
import TableFilterSelect from '../../../../../../../../components/_table/TableFilterSelect';
import { addAllItemToSelectList } from '../../../../../../../../lib/common';
import {
  EVENT_STATUS_SELECT_LIST,
  EVENT_STATUS_TEXT,
} from '../../../../../../../../constants/service/app/eventConstants';

/**
 *  태그에 연결된 아이템 컬림
 */
export const columns = (data) => {
  const { isFilter, filterOption, onFilter } = data;
  return [
    {
      title: <TableColumnTitle title={'기획전 ID'} filterValue={filterOption.id} />,
      dataIndex: 'id',
      className: !isFilter && 'not-filter',
      width: 120,
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          type="number"
          option={filterOption.id}
          confirm={confirm}
          placeholder="기획전 ID 검색"
          onFilter={(id) => onFilter({ id })}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'상태'} filterValue={EVENT_STATUS_TEXT[filterOption.status]} />,
      dataIndex: 'status',
      className: !isFilter && 'not-filter',
      width: 120,
      render: (value) => EVENT_STATUS_TEXT[value],
      filterDropdown: ({ confirm }) => (
        <TableFilterSelect
          list={addAllItemToSelectList(EVENT_STATUS_SELECT_LIST)}
          option={filterOption.status}
          confirm={confirm}
          onFilter={(status) => onFilter({ status })}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'제목'} filterValue={filterOption.mainTitle} />,
      dataIndex: 'mainTitle',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          option={filterOption.mainTitle}
          confirm={confirm}
          placeholder="기획전 제목 검색"
          onFilter={(mainTitle) => onFilter({ mainTitle })}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'기획전 기간'} />,
      dataIndex: 'period',
      width: 330,
    },
  ];
};
